exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-bar{width:100%;overflow:hidden}.search-component{background-color:var(--search-bar-color);border:0;color:var(--primary600);display:inline-block;margin:0;padding:6px;outline:none}.search-bar-mks{width:calc(100% - var(--search-bar-button-width)*2);border-radius:0}.search-icon{text-align:center;border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.search-icon,.search-submit-btn{width:var(--search-bar-button-width)}.search-submit-btn{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}", ""]);

// exports
